<section class="cr-static">
  <div class="cr-static__inner">
    <header class="cr-static__hero">
      <span class="cr-static__eyebrow">Über uns</span>
      <h1 class="cr-static__title">
        Handwerk verdient<br>besseres Marketing.
      </h1>
      <p class="cr-static__lead">
        Deshalb gibt es Craftly.
      </p>
    </header>

    <article class="cr-static__prose">
      <p>
        Wir sind <strong>Valentin</strong> und <strong>Thore</strong>. Wir haben Craftly gegründet,
        weil wir es leid waren: stundenlanges Anrufen, vage Preisangaben am Telefon, Termine,
        die platzen.
      </p>
      <p>
        Auf der anderen Seite: Handwerksbetriebe, die mit teuren Lead-Gebühren bei
        Vermittlungsplattformen Geld verbrennen, oder mit Kaltakquise und Mundpropaganda
        allein nicht weiterkommen.
      </p>
      <p>
        Craftly ist unsere Antwort: ein Marktplatz, der für beide Seiten fair ist.
        Festpreise statt Stundenrechnungen, treuhändische Zahlung statt Vorkasse,
        transparente <strong>15&nbsp;%</strong> Provision statt undurchschaubare Lead-Gebühren.
      </p>
    </article>

    <section class="cr-static__team">
      <h2 class="cr-static__h2">Die Gründer</h2>
      <div class="cr-static__team-grid">
        <article class="cr-static__person">
          <div class="cr-static__person-avatar" aria-hidden="true">T</div>
          <h3 class="cr-static__person-name">Thore</h3>
          <p class="cr-static__person-role">Co-Founder · Geschäftsführung &amp; Vertrieb</p>
        </article>
        <article class="cr-static__person">
          <div class="cr-static__person-avatar" aria-hidden="true">VK</div>
          <h3 class="cr-static__person-name">Valentin Kulagin</h3>
          <p class="cr-static__person-role">Co-Founder · Produkt &amp; Technik</p>
        </article>
      </div>
    </section>

    <section class="cr-static__values">
      <h2 class="cr-static__h2">Was uns unterscheidet</h2>
      <div class="cr-static__values-grid">
        <article class="cr-static__value">
          <span class="cr-static__value-label">Transparent</span>
          <p>Festpreis vorab. Keine versteckten Kosten — der Kunde weiß bei der Buchung, was er zahlt.</p>
        </article>
        <article class="cr-static__value">
          <span class="cr-static__value-label">Fair</span>
          <p>15&nbsp;% Provision auf vermittelte Aufträge. Keine Lead-Gebühren, keine Premium-Slots, keine Bezahl-Sichtbarkeit.</p>
        </article>
        <article class="cr-static__value">
          <span class="cr-static__value-label">Sicher</span>
          <p>Treuhand-Zahlung über Stripe. Das Geld bleibt im Hold, bis der Auftrag sauber erledigt ist.</p>
        </article>
      </div>
    </section>

    <section class="cr-static__company">
      <h2 class="cr-static__h2">Unternehmen</h2>
      <address class="cr-static__address">
        <strong>Kulatrix UG (haftungsbeschränkt)</strong><br>
        Alarichstraße 18<br>
        42281 Wuppertal<br>
        Amtsgericht Wuppertal, HRB 36763
      </address>
      <p class="cr-static__company-note">
        Vollständige Angaben gemäß § 5 DDG im
        <a routerLink="/impressum">Impressum</a>.
      </p>
    </section>

    <section class="cr-static__cta">
      <h2 class="cr-static__cta-title">Loslegen.</h2>
      <p class="cr-static__cta-lead">Direkt buchen oder als Handwerker dabei sein.</p>
      <div class="cr-static__cta-row">
        <a routerLink="/anfrage/neu" class="cr-btn cr-btn--primary">Als Kunde anfragen</a>
        <a routerLink="/registrieren/handwerker" class="cr-btn cr-btn--ghost">Als Handwerker anmelden</a>
      </div>
    </section>
  </div>
</section>
